/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Exercise_Remove_FilterInputs */

const en_us2_exercise_remove_filter = /** @type {(inputs: Exercise_Remove_FilterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.name}`)
};

const pt_br2_exercise_remove_filter = /** @type {(inputs: Exercise_Remove_FilterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remover ${i?.name}`)
};

const es_419_exercise_remove_filter = /** @type {(inputs: Exercise_Remove_FilterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Quitar ${i?.name}`)
};

const pt_pt2_exercise_remove_filter = /** @type {(inputs: Exercise_Remove_FilterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remover ${i?.name}`)
};

const fr_fr2_exercise_remove_filter = /** @type {(inputs: Exercise_Remove_FilterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Retirer ${i?.name}`)
};

const de_de2_exercise_remove_filter = /** @type {(inputs: Exercise_Remove_FilterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} entfernen`)
};

const it_it2_exercise_remove_filter = /** @type {(inputs: Exercise_Remove_FilterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rimuovi ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Remove {name}" |
*
* @param {Exercise_Remove_FilterInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_remove_filter = /** @type {((inputs: Exercise_Remove_FilterInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Remove_FilterInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_remove_filter(inputs)
	if (locale === "es-419") return es_419_exercise_remove_filter(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_remove_filter(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_remove_filter(inputs)
	if (locale === "de-DE") return de_de2_exercise_remove_filter(inputs)
	if (locale === "it-IT") return it_it2_exercise_remove_filter(inputs)
	return en_us2_exercise_remove_filter(inputs)
});
export { exercise_remove_filter as "exercise.remove_filter" }